import { Avatar, Tooltip } from '@mantine/core';
import { IconUserPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import useFetchPhotoTags from 'src/Hooks/Queries/useFetchPhotoTags';

import styles from './PhotoTagsOverlay.module.scss';
import { Props } from './PhotoTagsOverlay.types';

interface TaggedMember {
  tagId: string;
  memberId: string;
  firstName: string;
  lastName: string;
  imageUrl?: string;
}

const PhotoTagsOverlay = ({ storageFileId, onTagClick }: Props) => {
  const { t } = useTranslation();
  const { data: tags, isLoading } = useFetchPhotoTags(storageFileId);

  const typedTags = (tags ?? []) as TaggedMember[];
  const displayedTags = typedTags.slice(0, 3);
  const remainingCount = typedTags.length - displayedTags.length;

  return (
    <div className={styles.container}>
      <div>
        {!isLoading && typedTags.length > 0 && (
          <Tooltip label={t('photoTags.taggedPeople')}>
            <div className={styles.taggedPeople} onClick={onTagClick}>
              <div className={styles.avatarGroup}>
                {displayedTags.map(tag => {
                  const initials = (tag.firstName.charAt(0) + tag.lastName.charAt(0)).toUpperCase();
                  return (
                    <Avatar
                      key={tag.tagId}
                      src={tag.imageUrl}
                      size="sm"
                      color="initials"
                      name={initials}
                      className={styles.avatar}
                    />
                  );
                })}
              </div>
              <span className={styles.count}>
                {remainingCount > 0 ? `+${remainingCount}` : typedTags.length}
              </span>
            </div>
          </Tooltip>
        )}
      </div>

      <Tooltip label={t('photoTags.tagPerson')}>
        <div className={styles.tagButton} onClick={onTagClick}>
          <IconUserPlus size={20} />
        </div>
      </Tooltip>
    </div>
  );
};

export default PhotoTagsOverlay;
